import React, { useEffect } from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import { useLocation } from "react-router-dom";

function HowItWorks() {
  const { pathname } = useLocation();
  const [openIndex, setOpenIndex] = React.useState(null);

  const toggleItem = (index) => {
    console.log("index", index);
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const faq = [
    {
      question:
        "What is Salarytap and how does it work for employers and employees?",
      answer:
        "Salarytap is a platform that allows employees to access their salary on demand. Employers can upload their employee data to the Salarytap workspace and set a maximum withdrawal limit for each employee. Once the setup is complete, employees can immediately access funds through the <a href='https://shorturl.at/93EjL' style='color: blue;'>Salarytap app</a>, available on the Google Play Store. Employees can withdraw funds 24/7.",
    },
    {
      question: "How do employers set up their workspace on Salarytap?",
      answer: `
      Salarytap is a platform that allows employees to access their salary on demand. Employers can upload their employee data to the Salarytap workspace and set a maximum withdrawal limit for each employee. Once the setup is complete, employees can immediately access funds through the Salarytap app, available on Google Play Store. Employees can withdraw funds instantly.
      `,
    },
    {
      question:
        "Can employers customise Salarytap in their HR App or use their own funds for advancing salary to their employees?",
      answer:
        "Salarytap can be customised to integrate with the employer’s HR app, and if employers prefer to use their own funds for advancing salary, they can integrate their bank account to fund their employees",
    },
    {
      question: "What will it cost the employees?",
      answer: `Employees incur a one-time setup fee of Rs. 300 at the time of their first withdrawal.<br/>
         There is no interest charged, but a flat convenience fee is applied to each withdrawal. `,
    },
    {
      question: "What is the cost of custom integration?",
      answer:
        "Integrating Salarytap into the employer's HR app or choosing to use the employer's funds to facilitate employee funding will cost approximately Rs. 3 to 5 lakhs for each integration.",
    },
    {
      question:
        "What are the steps for employers to enable their employees to withdraw funds?",
      answer:
        "First, you'll need to create your 'Workspace.' After completing your 'Profile,' your workspace will be set up. Once the backend is configured, we'll notify you. At that point, you can upload your employee list, and your employees will be able to start withdrawing funds immediately.",
    },
  ];
  return (
    <>
      <Navbar />
      <div className="how-it-works-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold font-semibold mb-3">
              How Salarytap Works
            </h2>
            <p className="lead text-muted">
              A seamless solution for employers and employees
            </p>
          </div>

          {/* For Employers */}
          <div className="employers-section mb-5">
            <div className="text-center mb-4">
              <h3 className="fw-bold text-success mb-3">
                <i className="fas fa-building me-2"></i>For Employers
              </h3>
              <p className="text-muted fs-5">
                Empower your workforce with flexible, instant access to earned
                wages — with zero cost or credit risk to your company.
              </p>
            </div>

            <div className="row g-4">
              <div className="col-lg-4 col-md-6">
                <div className="card h-100 border-0 shadow-sm hover-effect">
                  <div className="card-header bg-success text-white">
                    <div className="step-number">1</div>
                    <h4 className="mb-0">Create Your Workspace</h4>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Set up your company's workspace on Salarytap. Upload
                      salary data manually, integrate using APIs, or connect
                      your HRMS system for full automation.
                    </p>
                  </div>
                  <div className="card-footer bg-transparent">
                    <i className="fas fa-laptop-code fa-2x text-success"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="card h-100 border-0 shadow-sm hover-effect">
                  <div className="card-header bg-success text-white">
                    <div className="step-number">2</div>
                    <h4 className="mb-0">Set Access Limits</h4>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Decide what percentage of earned salary employees can
                      access. (We recommend 50% of earned salary.)
                    </p>
                  </div>
                  <div className="card-footer bg-transparent">
                    <i className="fas fa-sliders-h fa-2x text-success"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-12">
                <div className="card h-100 border-0 shadow-sm hover-effect">
                  <div className="card-header bg-success text-white">
                    <div className="step-number">3</div>
                    <h4 className="mb-0">Seamless Salary Reconciliation</h4>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Limits are based on salary earned to date, preventing
                      excess withdrawals. At month-end, Salarytap provides a
                      summary of withdrawals. Deduct from payroll and make a
                      single payment.
                    </p>
                  </div>
                  <div className="card-footer bg-transparent">
                    <i className="fas fa-exchange-alt fa-2x text-success"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* For Employees */}
          <div className="employees-section mt-5">
            <div className="text-center mb-4">
              <h3 className="fw-bold text-primary mb-3">
                <i className="fas fa-users me-2"></i>For Employees
              </h3>
              <p className="text-muted fs-5">
                Enjoy instant access to your earned salary in just a few easy
                steps.
              </p>
            </div>

            <div className="row g-4">
              <div className="col-lg-3 col-md-6">
                <div className="card h-100 border-0 shadow-sm hover-effect">
                  <div className="card-header bg-primary text-white">
                    <div className="step-number">1</div>
                    <h4 className="mb-0">Sign Up in Minutes</h4>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Download the Salarytap app. Register with your mobile
                      number, PAN, and Aadhaar for quick verification.
                    </p>
                  </div>
                  <div className="card-footer bg-transparent">
                    <i className="fas fa-mobile-alt fa-2x text-primary"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="card h-100 border-0 shadow-sm hover-effect">
                  <div className="card-header bg-primary text-white">
                    <div className="step-number">2</div>
                    <h4 className="mb-0">Access Your Salary</h4>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Get up to 50% of your earned salary. No interest — just a
                      one-time setup fee of ₹100 and a convenience fee starting
                      at 1%.
                    </p>
                  </div>
                  <div className="card-footer bg-transparent">
                    <i className="fas fa-wallet fa-2x text-primary"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="card h-100 border-0 shadow-sm hover-effect">
                  <div className="card-header bg-primary text-white">
                    <div className="step-number">3</div>
                    <h4 className="mb-0">Withdraw Instantly</h4>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      Transfer to your bank, UPI ID, or pay via QR codes. Use
                      funds instantly for bills, shopping, or transfers.
                    </p>
                  </div>
                  <div className="card-footer bg-transparent">
                    <i className="fas fa-qrcode fa-2x text-primary"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="card h-100 border-0 shadow-sm hover-effect">
                  <div className="card-header bg-primary text-white">
                    <div className="step-number">4</div>
                    <h4 className="mb-0">Simple Repayment</h4>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      The balance is auto-deducted from your salary. Repay early
                      anytime to refresh your available limit instantly.
                    </p>
                  </div>
                  <div className="card-footer bg-transparent">
                    <i className="fas fa-hand-holding-usd fa-2x text-primary"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add this CSS in your stylesheet */}
        <style jsx>{`
          .how-it-works-section {
            background-color: #f8f9fa;
          }
          .card-header {
            position: relative;
            padding: 1.5rem;
          }
          .step-number {
            position: absolute;
            top: -15px;
            left: 20px;
            background: white;
            color: #333;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
          }
          .hover-effect {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .hover-effect:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
          }
          @media (max-width: 768px) {
            .card {
              margin-bottom: 20px;
            }
          }
        `}</style>
      </div>

      <Footer />
    </>
  );
}

export default HowItWorks;
